<template>
    <div class="order">
        <a-table :columns="columns" :data-source="tableData" @change="change_filter" :loading="loading" :pagination="page" bordered>
            <template slot="user" slot-scope="text, record">
                {{record.users_id}}<br/>{{record.users_truename}}<br />{{record.users_mobile}}
            </template>
            <template slot="pic" slot-scope="text, record">
                <div v-if="record.pic" class="pics">
                    <a-badge :count="record.pic.length"><a href="javascript:void(0);" @click="show_pic(record.pic)"><img :src="record.pic[0].url" /></a></a-badge>
                </div>
            </template>
            <template slot="operation" slot-scope="text, record">
                <a @click="()=>{process(record)}" v-if="$Func.check_rank('feedback_hf')">反馈回复</a>
                <a-divider type="vertical" />
            </template>
        </a-table>
        <a-drawer
          title="反馈回复"
          :width="720"
          :maskStyle="{backgroundColor: '#00000010'}"
          :visible="process_model"
          :body-style="{ paddingBottom: '80px' }"
          @close="process_model=false"
          v-if="$Func.check_rank('order_process')"
        >
            <a-form-model :model="order_process" :rules="process_rules" layout="vertical" ref="process_form" @submit="process_data">
                <a-form-model-item ref="content" prop="content" label="反馈内容">
                    <AEditor
                        v-model="order_process.note_hf"
                    />
                </a-form-model-item>
                <div :style="{position: 'absolute',right: 0,bottom: 0,width: '100%',borderTop: '1px solid #e9e9e9',padding: '10px 16px',background: '#fff',textAlign: 'right',zIndex: 1}">
                    <a-button :style="{ marginRight: '8px' }" @click="process_model=false">取消</a-button>
                    <a-button type="primary" html-type="submit">确定</a-button>
                </div>
            </a-form-model>
        </a-drawer>
        <Pics />
    </div>
</template>

<script>
    import Func from '../../common/func'
    import Pics from '../../components/Pics';
    import AEditor from '../../components/AEditor';
    const columns = [
        {
            title: '#',
            dataIndex: 'id',
            key: 'id',
            width: 80,
        },
        {
            title: '用户',
            dataIndex: 'users_truename',
            key: 'users_truename',
            scopedSlots: { customRender: 'user' },
            width: 150,
        },
        {
            title: '反馈内容',
            dataIndex: 'note',
            key: 'note',
            width: 130
        },
        {
            title: '反馈图片',
            dataIndex: 'pic',
            key: 'pic',
            width: 130,
            scopedSlots: { customRender: 'pic' },
        },
        // {
        //     title: '报价',
        //     dataIndex: 'price',
        //     key: 'price',
        //     ellipsis: true,
        //     width: 120,
        // },
        // {
        //     title: '处理',
        //     dataIndex: 'process_str',
        //     key: 'process_str',
        //     ellipsis: true,
        //     width: 90,
        // },
        {
            title: '状态',
            dataIndex: 'status_str',
            key: 'status_str',
            ellipsis: true,
            width: 90,
        },
        // {
        //     title: '状态时间',
        //     dataIndex: 'status_time',
        //     key: 'status_time',
        //     ellipsis: true,
        //     width: 180,
        // },
        {
            title: '反馈时间',
            dataIndex: 'created',
            key: 'created',
            ellipsis: true,
            width: 180,
        },
        {
            title: '操作',
            dataIndex: 'id',
            key:'operation',
            width: 160,
            scopedSlots: { customRender: 'operation' },
        },
    ];
    let search_user_timeout;
    let search_branch_timeout;
    let search_agent_timeout;
    let update_user_timeout;
    let update_branch_timeout;
    let update_agent_timeout;
    export default {
        name: 'order',
        components: {AEditor,Pics},
        data(){
            return {
                btypeOptions:[],
                schoolOptions:[],
                current: [0],
                status:0,
                columns,
                form: this.$form.createForm(this),
                keyword:'',
                range:[],
                tableData:[],
                type_list:[],
                search_user_fetching: false,
                search_user_value:undefined,
                search_user_list:[],

                search_branch_fetching: false,
                search_branch_value:undefined,
                search_branch_list:[],

                search_agent_fetching: false,
                search_agent_value:undefined,
                search_agent_list:[],

                search_type:'',

                //用户信息修改 begin
                update_user_fetching: false,
                update_user_value:'',
                update_user_list:[],

                update_branch_fetching: false,
                update_branch_value:'',
                update_branch_list:[],

                update_agent_fetching: false,
                update_agent_value:'',
                update_agent_list:[],
                //用户信息修改 end
                total:0,
                order_total:0,

                status_list:[
                    {
                        id:1,
                        title:'待报价'
                    },
                    {
                        id:2,
                        title:'已报价'
                    },
                    {
                        id:3,
                        title:'确认交易'
                    },
                    {
                        id:4,
                        title:'未交易'
                    },
                    {
                        id:8,
                        title:'已打款'
                    },
                    {
                        id:99,
                        title:'交易完成'
                    }
                ],
                loading:false,
                pic_loading:false,
                update_model:false,
                process_model:false,
                pic:'',
                base_url:Func.api_url,
                pic_url:Func.pic_url,
                order_update:{
                    id:0,
                    uid:'',
                    branch_id:'',
                    agent_id:'',
                    type:1,
                    mileage:'',
                    num:'',
                    weight:'',
                    capacity:'1',
                    pic:[],
                    note:'',
                    status:1,
                    price:''
                },
                order_process:{
                    id:0,
                    status:1,
                    price:''
                },
                rules: {
                    type:[{ required: true, message: '请选择电池类型', trigger: 'change' }],
                    mileage:[{ required: true, message: '请输入车辆里程', trigger: 'blur' }],
                    num:[{ required: true, message: '请输入总数量', trigger: 'blur' }],
                    weight:[{ required: true, message: '请输入总货重', trigger: 'blur' }],
                    capacity:[{ required: true, message: '请输入总容量', trigger: 'blur' }],
                    status:[{ required: true, message: '请选择状态', trigger: 'change' }]
                },
                process_rules: {
                    status:[{ required: true, message: '请选择状态', trigger: 'change' }]
                },
                page:{
                    current:1,
                    total:0,
                    pageSize:10
                }
            }
        },
        created() {
            this.get_data();
        },
        methods: {
            show_pic(data){
                this.$PubSub.publish('show_pics',data);
            },
            onChange(date, dateString) {
                this.range=dateString;
            },
            //指定用户 begin
            searchUserSearch(keyword) {
                if (search_user_timeout) {
                    clearTimeout(search_user_timeout);
                    search_user_timeout = null;
                }
                search_user_timeout = setTimeout(()=>{
                    Func.url_get({
                        action:'users.search',
                        keyword
                    },(res) => {
                        this.search_user_list = res.info.list;
                    });
                }, 300);
            },
            searchUserChange(value) {
                this.search_user_value=value;
            },

            searchBranchSearch(keyword) {
                if (search_branch_timeout) {
                    clearTimeout(search_branch_timeout);
                    search_branch_timeout = null;
                }
                search_branch_timeout = setTimeout(()=>{
                    Func.url_get({
                        action:'branch.search',
                        keyword
                    },(res) => {
                        this.search_branch_list = res.info.list;
                    });
                }, 300);
            },
            searchBranchChange(value) {
                this.search_branch_value=value;
            },

            searchAgentSearch(keyword) {
                if (search_agent_timeout) {
                    clearTimeout(search_agent_timeout);
                    search_agent_timeout = null;
                }
                search_agent_timeout = setTimeout(()=>{
                    Func.url_get({
                        action:'agent.search',
                        keyword
                    },(res) => {
                        this.search_agent_list = res.info.list;
                    });
                }, 300);
            },
            searchAgentChange(value) {
                this.search_agent_value=value;
            },

            //用户信息修改 begin
            updateUserSearch(keyword) {
                if (update_user_timeout) {
                    clearTimeout(update_user_timeout);
                    update_user_timeout = null;
                }
                update_user_timeout = setTimeout(()=>{
                    Func.url_get({
                        action:'users.search',
                        keyword
                    },(res) => {
                        this.update_user_list = res.info.list;
                    });
                }, 300);
            },
            updateUserChange(value) {
                this.order_update.uid = value;
                this.update_user_value=value;
            },

            updateBranchSearch(keyword) {
                if (update_branch_timeout) {
                    clearTimeout(update_branch_timeout);
                    update_branch_timeout = null;
                }
                update_branch_timeout = setTimeout(()=>{
                    Func.url_get({
                        action:'branch.search',
                        keyword
                    },(res) => {
                        this.update_branch_list = res.info.list;
                    });
                }, 300);
            },
            updateBranchChange(value) {
                this.order_update.branch_id = value;
                this.update_branch_value=value;
            },

            updateAgentSearch(keyword) {
                if (update_agent_timeout) {
                    clearTimeout(update_agent_timeout);
                    update_agent_timeout = null;
                }
                update_agent_timeout = setTimeout(()=>{
                    Func.url_get({
                        action:'agent.search',
                        keyword
                    },(res) => {
                        this.update_agent_list = res.info.list;
                    });
                }, 300);
            },
            updateAgentChange(value) {
                this.order_update.agent_id = value;
                this.update_agent_value=value;
            },
            //用户信息修改 end

            picUpdateChange(info) {
                let fileList = [...info.fileList];

                // 2. read from response and show file link
                fileList = fileList.map(file => {
                    if (file.response) {
                        // Component will show file.url as link
                        file.url = this.pic_url+file.response.url;
                    }

                    return file;
                });

                console.log(fileList);
                this.order_update.pic = fileList;
            },
            beforeUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 200;
                if (!isLt2M) {
                    this.$message.error('请上传200M以内文件!');
                }
                return isLt2M;
            },
            get_type() {
                Func.url_get({
                    action:'type.list_all'
                },(res) => {
                    this.type_list = res.info;
                });
            },
            change_tab(e){
                this.status=e.key;
                this.get_data(1);
            },
            change_filter(pagination){
                this.get_data(pagination.current);
            },
			get_data(page,tip) {
			    var keyword = this.keyword;
			    if (!page) {
			        page = this.page.current||1;
			    }
			
			    if(!tip){
			        this.loading = true
			    }
			
			    Func.url_get({
			        action:'bid.feedback_list',
			        // uid:this.search_user_value||'',
			        keyword: keyword,
			        page: page
			    },(res) => {
					if (res.error === 0) {
						this.tableData = res.info.list;
						var pagination={
							pageSize:10,
							total:res.info.foot.total,
							current:parseInt(res.info.foot.current)
						}
						this.page=pagination;
						this.loading = false
					} else {
						this.$message.error(res.info);
					}
			    });
			},
            get_data_old(page,tip) {
                var keyword = this.keyword;
                if (!page) {
                    page = this.page.current||1;
                }

                if(!tip){
                    this.loading = true
                }

                Func.url_get({
                    action:'order',
                    keyword: keyword,
                    range:this.range,
                    uid:this.search_user_value||'',
                    branch_id:this.search_branch_value||'',
                    agent_id:this.search_agent_value||'',
                    type:this.search_type,
                    status:this.status,
                    page: page
                },(res) => {
                    this.tableData = res.info.list;
                    var pagination={
                        pageSize:10,
                        total:res.info.foot.total,
                        current:parseInt(res.info.foot.current)
                    }
                    this.total=res.info.total;
                    this.order_total=res.info.order_total;
                    this.page=pagination;
                    this.loading = false
                });
            },
            export_data() {
                var url=this.base_url+'?action=order.export&keyword='+this.keyword+'&range='+this.range+'&uid='+(this.search_user_value||'')+'&branch_id='+(this.search_branch_value||'')+'&agent_id='+(this.search_agent_value||'')+'&type='+this.search_type+'&status='+this.status+'&adm_id='+this.$store.state.info.id+'&token='+this.$store.state.info.token;

                window.open(url);
                return;
            },
            save_data(e){
                e.preventDefault();
                this.$refs.update_form.validate(valid => {
                    if (valid) {
                        var pic=this.order_update.pic;
                        var pics=pic.map(file=>{
                            return file.url;
                        })
                        Func.url_post({
                            action:'order.save_data',
                            ...this.order_update,
                            pic:pics
                        },(res) => {
                            if(res.error===0){
                                this.$message.success(res.info);
                                this.update_model=false;
                                this.get_data(1,true);
                            }else{
                                this.$message.error(res.info);
                            }
                        });
                    }else{
                        return false;
                    }
                });
            },
            process(res){
				this.process_model=true;
                const item=JSON.parse(JSON.stringify(res));
				this.order_process=item;
                // Func.url_get({
                //     action:'bid.feedback_find',
                //     id:item.id
                // },(res) => {
                //     if(res.error===0){
                //         this.order_process=item;
                //         this.process_model=true;
                //     }else{
                //         this.$message.error(res.info);
                //     }
                // });
            },
            process_data(e){
                e.preventDefault();
                this.$refs.process_form.validate(valid => {
                    if (valid) {
                        Func.url_post({
                            action:'bid.feedback_hf',
                            ...this.order_process
                        },(res) => {
                            if(res.error===0){
                                this.$message.success(res.info);
                                this.process_model=false;
                                this.get_data(1,true);
                            }else{
                                this.$message.error(res.info);
                            }
                        });
                    }else{
                        return false;
                    }
                });
            },
            update_data(res){
                const item=JSON.parse(JSON.stringify(res));
                Func.url_get({
                    action:'users.search_one',
                    keyword:item.uid
                },(res) => {
                    this.update_user_list = res.info.list;
                });

                Func.url_get({
                    action:'branch.search_one',
                    keyword:item.branch_id
                },(res) => {
                    this.update_branch_list = res.info.list;
                });

                Func.url_get({
                    action:'agent.search_one',
                    keyword:item.agent_id
                },(res) => {
                    this.update_agent_list = res.info.list;
                });

                this.update_user_value=item.uid;
                this.update_branch_value=item.branch_id;
                this.update_agent_value=item.agent_id;

                this.order_update=item;

                this.update_model=true;
            },
            delete_data(item){
                if(confirm('确定要删除吗')==true){
                    Func.url_get({
                        action:'order.del_data',
                        id:item.id
                    },(res) => {
                        if(res.error===0){
                            this.$message.success(res.info);
                            this.get_data(1,true);
                        }else{
                            this.$message.error(res.info);
                        }
                    });
                }
            },
            goto_url(url,id){
                this.$router.push({
                    path:'/order/'+url,
                    params:{
                        id:id
                    }
                });
            }
        }
    }
</script>
<style scoped>
.ant-drawer-left.ant-drawer-open, .ant-drawer-right.ant-drawer-open,.ant-drawer{
      transition: transform 0.3s linear;
}
.modal-body{
    max-height: 700px;
    overflow: auto;
}
.ant-upload img{
    max-width:100%;
    max-height:100%;
}
.pics img{
    max-width: 100px;
    max-height: 100px;
}
.tabs{
    margin:10px 0;
}
.total{
    padding-bottom: 10px;
    font-size: 18px;
}
.total span{
    padding-right: 30px;
    color: red;
    font-size: 20px;
    font-weight: bolder;
}
/* tile uploaded pictures */
.upload-list-inline >>> .ant-upload-list-item {
  float: left;
  width: 90px;
  margin-right: 8px;
}
.upload-list-inline >>> .ant-upload-animate-enter {
  animation-name: uploadAnimateInlineIn;
}
.upload-list-inline >>> .ant-upload-animate-leave {
  animation-name: uploadAnimateInlineOut;
}
</style>